import type { SearchLocation } from '../type/api';

/**
 * Named location levels that change who matches. Ranking-only fields
 * (`coordinate`, `division`, `divisionCities`) must not appear on aggregation
 * requests: they do not affect facet counts and would partition the cache.
 */
export const SEARCH_LOCATION_NAME_LEVELS = [
    'suburb',
    'district',
    'city',
    'region',
    'state',
    'country',
] as const satisfies ReadonlyArray<keyof SearchLocation>;

/**
 * Pick the name levels from a search location for an aggregation request.
 */
export function toAggregationSearchLocation(
    searchLocation: SearchLocation,
): SearchLocation {
    const locationLevels: SearchLocation = {};
    for (const level of SEARCH_LOCATION_NAME_LEVELS) {
        const value = searchLocation[level];
        if (value) {
            locationLevels[level] = value;
        }
    }
    return locationLevels;
}
